import { Input as InputField } from "@chakra-ui/react"
import { colors } from "../colors/colors"

const sharedInputProps = {
  borderColor: "#D1D1D6",
  borderBottomWidth: "1px",
}

export function Input(props) {
  return (
    <InputField
      color="black"
      {...sharedInputProps}
      variant="flushed"
      _placeholder={{ color: `#8E8E93 ` }}
      focusBorderColor={colors.purple}
      {...props}
    />
  )
}
